import _ from 'lodash';

import googleAnalytics from '../tools/googleanalytics';
import controlPanelTour from './control-panel';
import infoBoardTour from './infoboard';
import searchTour from './searchbox';
import sidebarTour from './sidebar';
import startTour from './start';

const tour = (() => {
    let instance;

    const _category = 'Tour';

    const DEFAULT_OPTIONS = {
        autoscroll: true,
        duration: 10000
    };

    const _extendObjectArray = (objArray, overOption) => objArray.map(o => _.assign({}, o, overOption));

    const _tourTemplate = () => `
    <div class="popover tour">
      <div class="arrow"></div>
      <h3 class="popover-title"></h3>
      <div class="popover-content"></div>
      <div class="popover-navigation">
          <button class="btn btn-default" title="Anterior" data-role="prev"><i class="fa fa-arrow-left"></i></button>
          <button class="btn btn-default" title="Próximo" data-role="next"><i class="fa fa-arrow-right"></i></button>
          <button class="btn btn-danger" title="Finalizar Tour" data-role="end"><i class="fa fa-times"></i></button>
      </div>
      </nav>
    </div>
  `;

    const _isTourDoneOnce = () => window.localStorage.tour_end;

    const _begin = () => {
        if (instance) {
            instance.restart();
        } else {
            start();
        }
    };

    const start = () => {
        instance = new Tour({
            backdrop: false,
            delay: 1000,
            steps: [],
            template: _tourTemplate(),
            onEnd () {
                googleAnalytics.trackEventGA(_category, 'End');
            }
        });

        const tourSteps = [startTour, sidebarTour, controlPanelTour, infoBoardTour, searchTour];

        instance.addSteps(_extendObjectArray(tourSteps.reduce((prev, current) => prev.concat(current()), []), DEFAULT_OPTIONS));

        // Initialize the tour
        instance.init();
        instance.start();

        // TrackEventGA
        googleAnalytics.trackEventGA(_category, 'Initialize');
    };

    const stop = () => instance.end();

    const next = () => instance.next();

    const restart = () => instance.restart();

    const init = () => {
        if (_isTourDoneOnce()) {
            _begin();
        }

        $('#trigger-tour').show().on('click', e => {
            e.preventDefault();
            _begin();
        });
    };

    return {
        init,
        next,
        restart,
        start,
        stop
    };
})();

export default tour;



// WEBPACK FOOTER //
// ./src/scripts/core/tour/index.js